var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "info main-view" }, [
    _c("div", { staticClass: "info-container" }, [
      _c("div", { staticClass: "text-col" }, [
        _c("h2", [_vm._v(" Refinitiv Trade Discovery ")]),
        _c("p", [
          _vm._v(
            " In January 2019 the BCBS published revised Minimum capital requirements for market risk. These requirements mandated those institutions seeking internal model approval status to check the activity associated with the risk factors adopted in their models. This compliance test is called the risk factor eligibility test (RFET). "
          ),
        ]),
        _c("p", [
          _vm._v(
            ' The Refinitiv Trade Discovery aims to support banks pass RFET through the provision of "real" price observations. '
          ),
        ]),
        _c("p", [
          _vm._v(
            ' This application allows you to select your chosen sources of "real" price observation data and then define your instrument to risk factor mapping and review the results. For continuous attributes such as maturity, you can define custom buckets or adopt the pre-defined regulatory bucketing approach. You can then optimise your data sources and preferred bucketing methodology by comparing different scenarios within the application and export the results for further analysis. '
          ),
        ]),
        _c(
          "button",
          {
            staticClass: "button button-primary",
            on: {
              click: function ($event) {
                return _vm.start()
              },
            },
          },
          [_vm._v(" Start Using Trade Discovery ")]
        ),
      ]),
      _vm._m(0),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "image-col" }, [
      _c("img", {
        attrs: {
          src: require("./../assets/td_3d.png"),
          alt: "Picture of a graph",
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }